
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.9488 5.79884C12.9021 5.68753 12.8262 5.592 12.7298 5.52309C12.6334 5.45417 12.5203 5.41462 12.4032 5.40892H9.53108L11.3275 2.3285C11.3529 2.23211 11.3565 2.13096 11.338 2.0329C11.3195 1.93484 11.2794 1.84252 11.2209 1.76311C11.1618 1.6836 11.0858 1.61933 10.9988 1.57536C10.9117 1.53139 10.816 1.5089 10.7192 1.50966H6.32944C6.18786 1.50464 6.04881 1.54943 5.93493 1.63676C5.82106 1.72408 5.73907 1.84879 5.70232 1.99057L3.02167 8.48933C2.9961 8.58749 2.99311 8.69051 3.01295 8.79009C3.03279 8.88967 3.07491 8.98304 3.1359 9.06268C3.1969 9.14233 3.27508 9.20603 3.36415 9.24867C3.45323 9.2913 3.55072 9.31168 3.64878 9.30817H6.06316L4.92808 13.6883C4.8909 13.8296 4.90082 13.9797 4.95624 14.1144C5.01167 14.249 5.10935 14.3604 5.23346 14.4303C5.35757 14.5003 5.50084 14.5247 5.64005 14.4998C5.77925 14.4748 5.90625 14.4018 6.00044 14.2927L12.836 6.49421C12.9173 6.40185 12.9713 6.28711 12.9913 6.16377C13.0113 6.04043 12.9966 5.91371 12.9488 5.79884ZM6.80942 11.4398L7.4867 8.84026C7.51499 8.74246 7.52065 8.63913 7.50322 8.53864C7.48579 8.43815 7.44575 8.34333 7.38636 8.26187C7.32666 8.18147 7.24962 8.11667 7.16141 8.07266C7.07321 8.02865 6.97628 8.00665 6.8784 8.00842H4.47029L6.81231 2.80941H9.5L8.10754 5.88982C8.08197 5.98799 8.07898 6.09101 8.09882 6.19059C8.11866 6.29017 8.16077 6.38354 8.22177 6.46318C8.28277 6.54283 8.36095 6.60653 8.45002 6.64916C8.5391 6.6918 8.63659 6.71218 8.73465 6.70867H10.9734L6.80942 11.4398Z","fill":"#10001F"}})])
          )
        }
      }
    